(function () {
  if (window.__rvaSkuOn) return;
  window.__rvaSkuOn = 1;
  var NZ = {"24":{"Maroon":"3","Natural":"23","Pink":"2"},"29":{"Dark Olive":"2","Olive":"2","Royal Purple":"3","Sand Dune":"2","Vintage Denim":"2","Vintage Navy":"3"},"360":{"Maroon":"3"},"372":{"Heather Dark Navy":"2"},"1441":{"Blue Triblend":"3","Brick Triblend":"2","Brown Triblend":"2"},"1616":{"Misty Blue":"3"},"1787":{"Heather True Royal":"2"},"1829":{"Army Heather":"3","Classic Navy Heather":"3"},"2003":{"Grey Triblend":"3","Heather Red":"3","Lavender Blue":"3"},"2764":{"Black Heather/ Black":"2","Grey/ Maroon Triblend":"2","Grey/ Red Triblend":"2","Grey/ True Royal Triblend":"2"},"2768":{"Cardinal":"3","DTG Black":"23","Lavender Blue":"2","Mauve":"3","Silver":"3","Team Purple":"3"},"2769":{"Atlantic":"23","Black":"3","Black Heather":"3","Dark Grey":"3","Heather Deep Teal":"3","Steel Blue":"3","Teal":"3","Vintage Black":"3","Vintage Brown":"2"},"3497":{"Tahiti Blue":"3"},"6174":{"Dark Grey":"2"},"7584":{"Heather Prism Sunset":"23"},"970001":{"Heather Dusty Blue":"2"},"970005":{"Maroon":"2","Natural":"2","Pink":"2","True Royal":"2"},"970006":{"Peach":"2"},"970014":{"Antique Sapphire":"3","Azalea":"3","Heather Purple":"3","Irish Green":"3","Light Blue":"3"},"990017":{"Atlantic":"3","Bubblegum":"3","Butter":"3","Carolina Blue":"23","Charity Pink":"3","Coal":"23","Ecru":"3","Eucalyptus":"3","Forest Green":"23","Hydro":"3","Lime":"3","Mauve":"23","Midnight Blue":"3","Mineral":"3","Mushroom":"3","Mustard":"23","Orchid":"3","Pale Pink":"23","Petrol Blue":"23","Pistachio":"23","Powder":"3","Purple":"3","Sage":"2","Seafoam":"3","Walnut":"23"},"990018":{"Athletic Heather":"2","Hazy Pink":"2","Pale Pink":"2","Red":"2","Sage":"2"},"990019":{"Athletic Heather":"3","Bone":"3","Butter":"3","Ecru":"3","Eucalyptus":"3","Hazy Pink":"3","Navy":"3","Orchid":"3","Powder":"3","Sand":"3","Storm":"3"},"990020":{"Athletic Heather":"3","Bone":"3","Butter":"3","Charity Pink":"3","Ecru":"3","Hazy Pink":"3","Ink Blue":"3","Orchid":"3","Powder":"3","Shadow":"3","Storm":"3"}};
  var BASE = {
    2564: ["Black Reptile", "Brown Reptile", "Green Reptile", "Rainbow Stripe", "Shadow Stripe", "White Reptile"],
    2764: ["Grey/ True Royal Triblend"]
  };
  var DROP = { 970005: ["3XL"] };
  var BIGZ = /\b[4-9]XL\b/i;
  function noBig(list) { return Array.isArray(list) ? list.filter(function (b) { return !BIGZ.test(String(b)); }) : list; }
  function scrubDesc() {
    var D = window.RVA_DESC;
    if (!D) return;
    for (var k in D) {
      if (!Object.prototype.hasOwnProperty.call(D, k) || !Array.isArray(D[k]) || D[k].__rvaSku) continue;
      D[k] = noBig(D[k]);
      D[k].__rvaSku = 1;
    }
  }
  function fixStyle(st) {
    if (!st || st.__rvaSku) return;
    st.__rvaSku = 1;
    var b = BASE[st.sid];
    if (b && st.c) st.c.forEach(function (c) { if (b.indexOf(c[0]) >= 0 && c.length > 4) c[4] = null; });
    var d = DROP[st.sid];
    if (d && st.sz) {
      st.sz = st.sz.filter(function (z) { return d.indexOf(z) < 0; });
      if (st.sz.length) st.sizes = st.sz[0] + "–" + st.sz[st.sz.length - 1];
    }
    if (NZ[st.sid]) st.nz = NZ[st.sid];
  }
  var L = window.STYLES = window.STYLES || [];
  L.forEach(fixStyle);
  if (!L.__rvaSkuPush) {
    var push = L.push;
    L.push = function () { for (var i = 0; i < arguments.length; i++) fixStyle(arguments[i]); return push.apply(this, arguments); };
    L.__rvaSkuPush = 1;
  }
  function missing(e, z, c) {
    var m = e && e.nz;
    if (!m || !c) return false;
    var v = m[c[0]];
    if (!v) return false;
    return v.indexOf(z === "2XL" ? "2" : z === "3XL" ? "3" : "x") >= 0;
  }
  window.rvaSkuMissing = missing;
  function wrap(name, make) {
    var f = window[name];
    if (typeof f !== "function" || f.rvaSku) return false;
    var g = make(f);
    for (var k in f) if (Object.prototype.hasOwnProperty.call(f, k)) g[k] = f[k];
    g.rvaSku = 1;
    window[name] = g;
    return true;
  }
  function installCore() {
    if (typeof window.costOf !== "function" || typeof window.hasSz !== "function" || typeof window.swatchOf !== "function") return false;
    wrap("costOf", function (f) { return function (e, t) { if (e && t) e.__rvaC = t; return f.apply(this, arguments); }; });
    wrap("swatchOf", function (f) { return function (e) { var r = f.apply(this, arguments); if (e && r) e.__rvaC = r; return r; }; });
    wrap("hasSz", function (f) { return function (e, t, c) { if (!f.apply(this, arguments)) return false; return !missing(e, t, c || (e && e.__rvaC)); }; });
    wrap("addToRequest", function (f) { return function (e) { prune(e); return f.apply(this, arguments); }; });
    wrap("specsOf", function (f) { return function () { return noBig(f.apply(this, arguments)); }; });
    scrubDesc();
    return true;
  }
  function prune(e) {
    var S = window.S;
    if (!S || !S.draft || !e) return;
    var c = null;
    try { c = window.swatchOf(e); } catch (x) {}
    ["2XL", "3XL"].forEach(function (z) { if (S.draft[z] && missing(e, z, c)) delete S.draft[z]; });
  }
  function blankCells() {
    var S = window.S, P = document.getElementById("panel");
    if (!S || !P || !S.open || typeof window.styleById !== "function") return;
    var e = window.styleById(S.open);
    if (!e || !e.nz) return;
    var c = window.swatchOf(e), m2 = missing(e, "2XL", c), m3 = missing(e, "3XL", c);
    if (!m2 && !m3) return;
    Array.prototype.forEach.call(P.querySelectorAll("table"), function (tb) {
      var th = tb.querySelectorAll("thead th");
      if (th.length !== 4 || String(th[2].textContent).indexOf("2X") !== 0) return;
      Array.prototype.forEach.call(tb.querySelectorAll("tbody tr"), function (r) {
        if (m2 && r.cells[2]) r.cells[2].innerHTML = '<span class="na">&mdash;</span>';
        if (m3 && r.cells[3]) r.cells[3].innerHTML = '<span class="na">&mdash;</span>';
      });
    });
  }
  function installPanel() {
    return wrap("drawPanel", function (f) {
      return function () {
        try { var S = window.S; if (S && S.open && typeof window.styleById === "function") prune(window.styleById(S.open)); } catch (x) {}
        var o = f.apply(this, arguments);
        try { blankCells(); } catch (x) {}
        return o;
      };
    });
  }
  var tries = 0, iv = setInterval(function () { if (installCore() || ++tries > 200) clearInterval(iv); }, 50);
  installCore();
  function late() { scrubDesc(); setTimeout(installPanel, 0); setTimeout(installPanel, 1600); setTimeout(installPanel, 4000); }
  if (document.readyState === "complete") late(); else window.addEventListener("load", late);
})();
